import React from 'react';
import cn from 'classnames';
import ViewMessage from '@components/ViewMessage';
import { NavPeopleIcon, TrashIcon } from '@repo/icons';
import { Key } from '@repo/components/tooltips';
import { useNavigate } from 'react-router-dom';
import styles from './People.module.scss';

export default function EmptyPeople() {
  const navigate = useNavigate();

  return (
    <ViewMessage
      underHeader
      icon={<NavPeopleIcon color="textPrimary" width="20" height="20" />}
      headline="No People yet"
      message={
        <>
          Add a new person by
          <br />
          typing <Key>P</Key>
          <button className={cn(styles.archiveBtn)} onClick={() => navigate('/archive')}>
            View your Archive{' '}
            <TrashIcon
              width="14"
              height="14"
              hover={false}
              hoverOpacity={false}
              color="textPrimary"
            />
          </button>
        </>
      }
    />
  );
}
